import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, scale, fill, spacing, rotation, gradient, verticalOffset }) {
  const randomGradientId1 = `_${useRandomId()}`
  const randomGradientId2 = `_${useRandomId()}`

  const leftTransformOrigin = '12.9202 8.8951'
  const rightTransformOrigin = '44.6404 8.8951'

  return (
    <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`}>
      <g
        transform={`translate(${-spacing}) rotate(${rotation}) scale(${scale},${scale})`}
        transform-origin={leftTransformOrigin}
      >
        <path
          d="M23.44 8.89509C23.44 8.89509 21.48 4.32508 12.96 3.32508C6.33 2.54508 2.42 8.45509 2.42 8.45509L0 12.3651L24.94 14.5951C25.76 13.6751 24.52 10.3751 23.44 8.89509Z"
          fill={`url(#${randomGradientId1})`}
        />
        <path
          d="M23.4302 8.89513C23.4302 8.89513 13.3002 -1.23487 2.41016 8.45512C2.41016 8.45512 12.6102 -8.73487 23.4302 8.89513Z"
          fill={fill}
        />
      </g>
      <g
        transform={`translate(${spacing}) rotate(${-rotation}) scale(${scale},${scale})`}
        transform-origin={rightTransformOrigin}
      >
        <path
          d="M34.1299 8.89509C34.1299 8.89509 36.0899 4.32508 44.6099 3.32508C51.2399 2.54508 55.1499 8.45509 55.1499 8.45509L57.5699 12.3651L32.6299 14.5951C31.8099 13.6751 33.0399 10.3751 34.1299 8.89509Z"
          fill={`url(#${randomGradientId2})`}
        />
        <path
          d="M34.1304 8.89513C34.1304 8.89513 44.2604 -1.23487 55.1504 8.45512C55.1504 8.45512 44.9504 -8.73487 34.1304 8.89513Z"
          fill={fill}
        />
        <defs>
          <linearGradient
            id={randomGradientId1}
            x1="12.6031"
            y1="16.5563"
            x2="12.6031"
            y2="6.25042"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.2877" stopColor={gradient[1]} stopOpacity="0" />
            <stop offset="0.8775" stopColor={gradient[0]} stopOpacity=".5" />
          </linearGradient>
          <linearGradient
            id={randomGradientId2}
            x1="44.9665"
            y1="16.5563"
            x2="44.9665"
            y2="6.25042"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.2877" stopColor={gradient[1]} stopOpacity="0" />
            <stop offset="0.8775" stopColor={gradient[0]} stopOpacity=".5" />
          </linearGradient>
        </defs>
      </g>
    </g>
  )
}
